import { styled } from 'baseui'
import { RAIL_OVERLAY_Z_INDEX } from '@/shared/theme/railSlot'
import type { RailHoverBubbleSide } from './RailHoverBubble'

export const StyledHoverBubble = styled<'div', { $side: RailHoverBubbleSide }>('div', ({ $theme, $side }) => ({
  position: 'fixed',
  zIndex: RAIL_OVERLAY_Z_INDEX,
  transform: $side === 'right' ? 'translateY(-50%)' : 'translate(-100%, -50%)',
  paddingTop: '0.375rem',
  paddingBottom: '0.375rem',
  paddingLeft: '0.625rem',
  paddingRight: '0.625rem',
  borderRadius: '0.375rem',
  backgroundColor: $theme.colors.tooltipBackground,
  color: $theme.colors.tooltipText,
  fontSize: '0.8125rem',
  fontWeight: 500,
  lineHeight: '1.125rem',
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
  boxShadow: $theme.lighting.shadow500,
  animationName: {
    from: { opacity: 0, marginLeft: $side === 'right' ? '-0.25rem' : '0.25rem' },
    to: { opacity: 1, marginLeft: 0 },
  },
  animationDuration: '120ms',
  animationTimingFunction: 'ease-out',
  '::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    ...($side === 'right' ? { left: '-0.25rem' } : { right: '-0.25rem' }),
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '1px',
    backgroundColor: $theme.colors.tooltipBackground,
    transform: 'translateY(-50%) rotate(45deg)',
  },
}))
